import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import colors from 'hsl-shared-components/lib/Theme/colors';
import crossIcon from '../../assets/icons/icon-cross.svg';
import {
  MOBILE_BREAKPOINT_IN_PX,
  TABLET_BREAKPOINT_IN_PX,
} from '../../constants';

const BubbleWrapper = styled.div`
  position: relative;
  width: 428px;

  @media screen and (max-width: ${TABLET_BREAKPOINT_IN_PX}px) {
    width: 350px;
  }

  @media screen and (max-width: ${MOBILE_BREAKPOINT_IN_PX}px) {
    width: 255px;
  }
`;

const BubbleCross = styled.div`
  position: absolute;
  top: 17px;
  right: 17px;
  background-image: url(${crossIcon});
  background-repeat: no-repeat;
  background-position: center;
  background-size: 16px;
  height: 12px;
  width: 12px;
  color: ${colors.primary.hslWhite};
  padding: 0;
  cursor: pointer;

  @media screen and (max-width: ${MOBILE_BREAKPOINT_IN_PX}px) {
    background-size: 12px;
    height: 9px;
    width: 9px;
  }

  &:focus,
  &:active {
    outline: none;
  }
`;

const BubbleBackground = styled.div`
  background-color: ${colors.primary.hslWhite};
  border-radius: 5px;
  border: 1px solid #ccc;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.15);
  padding: 15px 46px 15px 15px;
  font-size: 16px;
`;

const Bubble = ({ onClose, children }) => (
  <BubbleWrapper>
    <BubbleCross onClick={onClose} />
    <BubbleBackground>{children}</BubbleBackground>
  </BubbleWrapper>
);

Bubble.propTypes = {
  onClose: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
};

export default Bubble;
